export const removeCurrency = (price = '') => price.replace(/[^\d.,]/g, '')
